import Immutable from 'immutable';

import type ErrorData from 'sharedreact/data/ErrorData';
import WebApp from 'sharedreact/data/WebApp';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

type OnFetchSuccess = (values: Immutable.List<WebApp>) => void;
type OnFetchError = (error: ErrorData) => void;

function fetch (onSuccess: OnFetchSuccess, onError: OnFetchError): void {
  ConnectionSupport.post(
    'services/getAppsList',
    {},
    (data) => onSuccess(Immutable.List(data.map((app: object) => new WebApp(app)))),
    onError,
    false
  );
}

export default {
  fetch
};
